module.exports = __webpack_public_path__ + "static/media/sf_500_gray.901a94780debce92e545f5ba304da397.png";